import React from 'react';

import LinkifiedText from '../../../shared/LinkifiedText/LinkifiedText';
import Button from '../../buttons/Button/Button';

import './TeamCard.css';

const TeamCard = ({
  firstName,
  lastName,
  title,
  desc,
  image,
  link,
  serviceLink,
  leftDesc,
}) => {
  const fullName = `${firstName} ${lastName}`;
  return (
    <div
      className='team-cardContainer'
      style={{ backgroundImage: `url("${image}")` }}
    >
      <div id='team-desc-container'>
        <div id='team-desc-content-container'>
          <h1 id='team-name'>{fullName}</h1>
          <p id='team-title'>{title}</p>
          {leftDesc && (
            <p id='team-desc__left'>
              <LinkifiedText>{leftDesc}</LinkifiedText>
            </p>
          )}
        </div>
        <div id='team-desc-button-container'>
          {link && <Button href={link}>Book Appointment</Button>}
        </div>
      </div>
      <div id='team-title-container'>
        <span id='team-name'>{fullName}</span>
        <span id='team-title'>{title}</span>
      </div>
      {link && (
        <div className='team-booking-btn-container'>
          <Button href={link}>Book Appointment</Button>
        </div>
      )}
      {serviceLink && (
        <div className='service__btn'>
          <Button href={serviceLink}>Book Appointment</Button>
        </div>
      )}
    </div>
  );
};

export default TeamCard;
